import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
  ViewRef,
} from '@angular/core';
import { RouterModule, UrlSegment } from '@angular/router';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { ContentTypeEnum, EContentPanelRoute, IContentFilterBlock, Subject } from 'lingo2-models';
import { IconComponent } from '../../../../shared/icon/icon.component';

@Component({
  selector: 'app-subject-item',
  templateUrl: './subject-item.component.html',
  styleUrls: ['./subject-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LocaleSharedModule, CommonModule, IconComponent, RouterModule],
})
export class SubjectItemComponent {
  private cdr = inject(ChangeDetectorRef);

  @Input() public set panel(value: IContentFilterBlock) {
    this._panel = value;
    this.prepare();
  }
  public get panel() {
    return this._panel;
  }
  @Input() link: UrlSegment;
  @Input() baseRoute: EContentPanelRoute;
  @Output() makeFavorite: EventEmitter<IContentFilterBlock> = new EventEmitter<IContentFilterBlock>();
  public coverUrl;
  public contentTypeEnum = ContentTypeEnum;

  private _panel: IContentFilterBlock;

  public onMakeFavorite(event: Event, panel: IContentFilterBlock) {
    event.stopPropagation();
    // event.preventDefault();
    this.makeFavorite.emit(panel);
  }

  public getTotalLabel(): string {
    switch (this.baseRoute) {
      case EContentPanelRoute.tutors:
        return 'library.content-filter.total-teachers';
      case EContentPanelRoute.classes:
        return 'library.content-filter.total-individual-lessons';
      default:
        return 'library.content-filter.total';
    }
  }

  protected prepare() {
    switch (this._panel.type) {
      case 'subject':
        const item = this._panel.item as any as Subject;
        if (item.cover && item.cover.md) {
          this.coverUrl = item.cover.md.url;
        } else {
          this.coverUrl = '';
        }
        this.detectDataChanges();
        break;
    }
  }

  private detectDataChanges() {
    if (this.cdr && !(this.cdr as ViewRef).destroyed) {
      this.cdr.markForCheck();
    }
  }
}
